import { AccountAllocationComparisonGrid } from '@components/AccountAllocationGrid/AccountAllocationComparisonGrid';
import type { AccountAllocationGridReport } from '@components/AccountAllocationGrid/types';
import { Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import type { AccountAllocationComparison } from '../editAccountAllocations/reviewAccountAllocationsModel';

export type ReviewAccountAllocationsComparisonProp = {
  report: AccountAllocationGridReport;
  comparison: AccountAllocationComparison;
  testId: string;
};

export const ReviewAccountAllocationsComparison = ({
  report,
  comparison,
  testId,
}: ReviewAccountAllocationsComparisonProp) => {
  const { t } = useTranslation('workflowCompletions');

  return (
    <>
      <Typography
        variant='bodySmall'
        component='p'
        sx={{ mb: 2 }}
        data-testid={`${testId}-change-summary`}
      >
        {comparison.changedCount === 0
          ? t('reviewAccountAllocations.noChanges')
          : t('reviewAccountAllocations.changeCount', {
              count: comparison.changedCount,
            })}
      </Typography>
      <AccountAllocationComparisonGrid
        report={report}
        comparison={comparison}
      />
    </>
  );
};
